





























import { Component, Vue, Prop } from 'vue-property-decorator';
import FileService, { FileViewModel } from '../../api/file';
import BookDetail from '../Book/Detail.vue';
import StructTree from '../CourseStruct/Tree.vue';
import FilePreview from './Preview.vue';
import { PagedList } from '../../api/PagedList';
import global from '../../utils/global';
import FileList from './List.vue';
@Component({
  components: {
    BookDetail,
    StructTree,
    FilePreview,
    FileList,
  },
})
export default class FileIndex extends Vue {
  private bookId: number = 0;
  private bookGuid: string = '';
  private service: FileService = new FileService();
  private tabActiveName: string = '0';
  private condition: FileViewModel = this.service.NewModel;
  private showPreview: boolean = false;
  private currentItem: FileViewModel = this.service.NewModel;
  private totalCount: number = 0;
  private created() {
    this.bookGuid = this.$route.query.id + '';
    this.condition.isPublic = 1;
  }
  private node_OnChange(data: any) {
    console.log(data);
    this.condition = this.service.NewModel;
    this.tabActiveName = '0';
    this.condition.userID = '';
    this.condition.isPublic = 1;
    if (data.level === 0 ) {
      this.condition.bookID = data.id;
      // this.search(this.condition, 1);
    } else if (data.nodeType === 1) {
      this.condition.courseStructID = data.id;
      // this.search(this.condition, 1);
    }
  }
  private tab_OnClick(tab: any, event: any) {
    const newCondition = this.service.NewModel;
    newCondition.bookID = this.condition.bookID;
    newCondition.courseStructID = this.condition.courseStructID;
    if (tab.name === '0') {
      newCondition.isPublic = 1;
      newCondition.userID = '';
      // this.$set(this.condition, 'isPublic', 1);
      // this.$set(this.condition, 'userID', '');
    } else {
      newCondition.isPublic = 0;
      newCondition.userID = global.getUserId();
      // this.$set(this.condition, 'isPublic', 0);
      // this.$set(this.condition, 'userID', global.getUserId());
    }
    this.condition = newCondition;
  }
  private btnPreview_OnClick(item: FileViewModel) {
    this.currentItem = item;
    this.showPreview = true;
  }
  private fileList_OnLoaded(totalCount: number) {
    this.totalCount = totalCount;
  }
}
